import { useState } from "react"
import logo from "../Images/logo.png"
import Error from "../Components/Error";
import LoadingButton from "../Components/LoadingButton";
import { useNavigate, useParams } from "react-router-dom";
import OrganizationAxiosInstance from "../Services/OrganizationAxiosInstance";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";


const UpdatePassword:React.FC = ()=>{

    const {token} = useParams<{token:string}>()
    const [password,setPassword] = useState('')
    const [confirmPassword,setConfirmPassword] = useState('')
    const [error,setErrror] = useState('')
    const [loading, setLoading] = useState(false)
    const [message,setMessage] = useState("")
     const [showPassword1, setShowPassword1] = useState(false);
     const [showPassword2, setShowPassword2] = useState(false);


    const navigate = useNavigate()
    // Send verification code
    const triggerReset = async () => {
      setLoading(true);
      try {
          await axios.post(
              `${process.env.REACT_APP_HOST}Organization/update-password`,
              { token, password }
          );
          setMessage("Password updated successfully!");
          navigate('/Login-org')
      } catch (error) {
          console.error("Error:", error);
          setErrror("Invalid or expired reset link. Please request a new one.");
      } finally {
          setLoading(false);
      }
  };
  

    const handleConfirmPasswordChange = (value:string)=>{
        setConfirmPassword(value);
        password!=value ? setErrror("Confirm Password Should be same as Password"):setErrror('') 
    }

    return (
    <>
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img className="mx-auto w-20 " src={logo} alt="Vit"/>
        <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Create a new Password</h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" action="#" method="POST">
          <div>
            <label htmlFor="password"  className="block text-sm/6 font-medium text-gray-900">Password</label>
            <div className="mt-2 flex ">
              <input value={password} type={showPassword1 ? "text" : "password"} onChange={(emai)=>{setPassword(emai.target.value)}} name="password" id="password" autoComplete="password" required className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-brand-600 sm:text-sm/6"></input>
               <button
                              type="button"
                              onClick={() => setShowPassword1(!showPassword1)}
                              className=" flex items-center pr-3 text-gray-500 hover:text-gray-700"
                            >
                              {showPassword1 ? (
                              <FaEyeSlash className="h-5 w-5" />
                            ) : (
                              <FaEye className="h-5 w-5" />
                            )}
                            </button>
            </div>
          </div>

          <div>
            <label htmlFor="confirmPassword"  className="block text-sm/6 font-medium text-gray-900">Confirm Password</label>
            <div className="mt-2 flex">
              <input value={confirmPassword} type={showPassword2 ? "text" : "password"} onChange={(emai)=>{handleConfirmPasswordChange(emai.target.value)}} name="confirmPassword" id="confirmPassword" autoComplete="confirmPassword" required className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-brand-600 sm:text-sm/6"></input>
                      <button
                              type="button"
                              onClick={() => setShowPassword2(!showPassword2)}
                              className=" flex items-center pr-3 text-gray-500 hover:text-gray-700"
                            >
                              {showPassword2 ? (
                              <FaEyeSlash className="h-5 w-5" />
                            ) : (
                              <FaEye className="h-5 w-5" />
                            )}
                            </button>     
            </div>
          </div>
            <p>{message}</p>
          {error?
            <Error message={error} />: "" }
          <div>  
          {loading? <LoadingButton/>:<button type="button" onClick={()=>{triggerReset()}} className="flex w-full justify-center rounded-md bg-brand-600 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-brand-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600">Update</button>
             }</div>
        </form>
      </div>
    </div>
      </>)
}

export default UpdatePassword